(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/prescript.js');

svs.playerLoginReact = svs.playerLoginReact || {};
svs.playerLoginReact.store = svs.playerLoginReact.store || {};
svs.playerLoginReact.store.actions = svs.playerLoginReact.store.actions || {};
svs.playerLoginReact.constants = svs.playerLoginReact.constants || {};
svs.playerLoginReact.login = svs.playerLoginReact.login || {};
svs.playerLoginReact.login.components = svs.playerLoginReact.login.components || {};
svs.playerLoginReact.registrate = svs.playerLoginReact.registrate || {};
svs.playerLoginReact.registrate.components = svs.playerLoginReact.registrate.components || {};
svs.playerLoginReact.bankid = svs.playerLoginReact.bankid || {};
svs.playerLoginReact.bankid.components = svs.playerLoginReact.bankid.components || {};
svs.playerLoginReact.frejaeid = svs.playerLoginReact.frejaeid || {};
svs.playerLoginReact.frejaeid.components = svs.playerLoginReact.frejaeid.components || {};
svs.playerLoginReact.sharedComponents = svs.playerLoginReact.sharedComponents || {};

svs.playerLoginReact.logger = new svs.core.log.Logger('module:player-login-react');

svs.playerLoginReact.data = svs.playerLoginReact.data || {};
svs.playerLoginReact.data.login = svs.playerLoginReact.data.login || {};


 })(window);